import RevenueCard from "./RevenueCard";
import RevenueGraph from "./RevenueGraph";
import InfoTooltip from "../InfoTooltip";
import { trpc } from "../../trpc";

type RevenueLigthSectionProps = {
  selectedMonth: string;
  selectedYear: string;
  trmValue: number;
  formatCurrency: (value: number) => string;
  formatUSD: (value: number) => string;
  revenueType?: string;
};

const RevenueLigthSection = ({
  selectedMonth,
  selectedYear,
  trmValue,
  formatCurrency,
  formatUSD,
  revenueType,
}: RevenueLigthSectionProps) => {
  const normalizedRevenueType = revenueType === "all" ? undefined : revenueType;

  const { data: revenueLigthData, isLoading: isRevenueLigthLoading } =
    trpc.revenue.lightRevenue.useQuery(
      {
        month: selectedMonth,
        year: selectedYear,
        revenueType: normalizedRevenueType,
      },
      {
        enabled: !!selectedMonth && !!selectedYear,
      }
    );

  const { data: revenueLigthGraphData, isLoading: isRevenueLigthGraphLoading } =
    trpc.revenue.lightRevenueGraph.useQuery({
      revenueType: normalizedRevenueType,
    });

  const revenueLigth = revenueLigthData?.revenue || 0;
  const mrrLigth = revenueLigth / trmValue;
  const arrLigth = mrrLigth * 12;

  const previousMonthRevenue = revenueLigthData?.previousMonth?.revenue;
  const previousMonthActiveMerchants = revenueLigthData?.previousMonth?.activeMerchants;
  const previousMonthMrr = previousMonthRevenue ? previousMonthRevenue / trmValue : undefined;
  const previousMonthArr = previousMonthMrr ? previousMonthMrr * 12 : undefined;

  return (
    <div>
      <div className="mb-2">
        <p className="text-lg font-semibold text-gray-700 inline">
          Revenue basado en el consumo mínimo del merchant - MRR ligth
        </p>
        <InfoTooltip
          text="Suma de la tarifa mínima mensual de todos los merchants activos."
          placement="top"
          size="md"
        />
      </div>
      <div className="grid grid-cols-1 md:grid-cols-2 xl:grid-cols-4 gap-6 w-full">
        <RevenueCard
          title="Total Merchants Active"
          value={revenueLigthData?.activeMerchants || 0}
          subtitle="Active customers"
          isLoading={isRevenueLigthLoading}
          formatValue={(value) => value.toString()}
          previousValue={previousMonthActiveMerchants}
        />

        <RevenueCard
          title="Total Minimum Consumption"
          value={revenueLigth}
          subtitle="Minimum revenue (COP)"
          isLoading={isRevenueLigthLoading}
          formatValue={formatCurrency}
          previousValue={previousMonthRevenue}
        />

        <RevenueCard
          title="MRR"
          value={mrrLigth}
          subtitle="Monthly Recurring Revenue (USD)"
          isLoading={isRevenueLigthLoading}
          formatValue={formatUSD}
          previousValue={previousMonthMrr}
        />

        <RevenueCard
          title="ARR"
          value={arrLigth}
          subtitle="Annual Recurring Revenue (USD)"
          isLoading={isRevenueLigthLoading}
          formatValue={formatUSD}
          previousValue={previousMonthArr}
        />
      </div>

      <RevenueGraph
        data={revenueLigthGraphData}
        isLoading={isRevenueLigthGraphLoading}
        trmValue={trmValue}
        title="MRR Ligth & Active Merchants Over Time"
      />
    </div>
  );
};

export default RevenueLigthSection;
